import React from 'react';
import { Toaster } from 'react-hot-toast';
import { ApolloProvider } from "@apollo/client";

import { client } from './src/apollo/client';
import Layout from './src/components/Layout';
import CookieConsent from './src/components/CookieConsent';
import { CartProvider } from './src/contexts/CartContext';
import { AuthProvider } from './src/hooks/useAuth';
import { LoadingProvider } from './src/contexts/LoadingContext';
import { WishlistProvider } from './src/contexts/WishlistContext';
import { requestMegaMenuClose } from './src/utils/megaMenuEvents';

import './src/styles/globals.css';
import './src/styles/forms.css';

// Work Sans
import "@fontsource/work-sans/latin-400.css";
import "@fontsource/work-sans/latin-500.css";
import "@fontsource/work-sans/latin-600.css";
import "@fontsource/work-sans/latin-700.css";
import "@fontsource/work-sans/latin-800.css";
import "@fontsource/work-sans/latin-900.css";

// Montserrat
import "@fontsource/montserrat/latin-400.css";
import "@fontsource/montserrat/latin-500.css";
import "@fontsource/montserrat/latin-600.css";
import "@fontsource/montserrat/latin-700.css";
import "@fontsource/montserrat/latin-800.css";
import "@fontsource/montserrat/latin-900.css";

// Inter
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/latin-600.css";

export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>
    <AuthProvider>
      <WishlistProvider>
        <CartProvider>
          <LoadingProvider>
            {element}
          </LoadingProvider>
        </CartProvider>
      </WishlistProvider>
    </AuthProvider>
  </ApolloProvider>
)

// Keep consent UI out of wrapRootElement, which Gatsby also mounts for Head.
export const wrapPageElement = ({ element, props }) => {
  return (
    <CookieConsent>
      <Layout {...props}>
        {element}
        <Toaster />
      </Layout>
    </CookieConsent>
  )
}

// Listen for route updates
export const onPreRouteUpdate = () => {
  requestMegaMenuClose();

  if (window.setLoading) {
    window.setLoading(true); // Show loader before navigation
  }
};

export const onRouteUpdate = () => {
  if (window.setLoading) {
    window.setLoading(false); // Hide loader after navigation
  }
};
